import DelayLoading from '../delayLoading';
export const selectedVesselDelayLoading = new DelayLoading();
